var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-wrapper"},[_c('Header',{attrs:{"title":'Tags'}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-contents"},[_c('div',{staticClass:"value-container"},[_c('div',{staticClass:"value-header"},[_c('h2',[_vm._v("Tags")]),_c('a',[_vm._v("Add")])])])])
}]

export { render, staticRenderFns }